export default __webpack_public_path__ + "static/media/reveal-logo-white.c3743113.png";